import {
  Goal,
  goalInboxID,
  HabitSortingMode,
  ID,
  Task,
  WeekDays,
} from '@griply/types';

import { getSortedTasks } from './get-sorted-tasks';
import { GoalGroupedTasks, groupTasksByGoal } from './group-tasks-by-goal';
import { habitSortingModeToSortingMode } from './habit-sorting-mode-to-sorting-mode';

export type BuildGoalHabitSectionsOptions = {
  habits: Task[];
  goals: Goal[];
  goalSorting?: string[];
  habitSortingMode?: HabitSortingMode;
  habitGroupSorting?: Record<string, ID[]> | null;
  today: Date;
  weekStartsOn: WeekDays;
};

export const buildGoalHabitSections = (
  options: BuildGoalHabitSectionsOptions,
): GoalGroupedTasks[] => {
  const {
    habits,
    goals,
    goalSorting,
    habitSortingMode,
    habitGroupSorting,
    today,
    weekStartsOn,
  } = options;

  const groups = groupTasksByGoal({
    tasks: habits,
    goals,
    goalSorting,
  });

  return groups.map<GoalGroupedTasks>((group) => ({
    ...group,
    tasks: getSortedTasks(group.tasks, {
      today,
      weekStartsOn,
      mode: habitSortingMode
        ? [habitSortingModeToSortingMode[habitSortingMode]]
        : undefined,
      order:
        habitGroupSorting?.[
          group.goalId === goalInboxID ? 'null' : group.goalId
        ] ?? [],
    }),
  }));
};
